import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';

const ActualFit = ({ fit }) => {
    const positionPercentage = ((fit - 1) / 4) * 100;

    if (!fit) {
        return;
    }

    return (
        <Box position="relative"
            width="100%"
            mt={1}>
            <Box height="1px"
                backgroundColor="grey.600"
                width="100%">
            </Box>
            <Box
                position="absolute"
                top="-4px"
                left={positionPercentage + "%"}
                transform="translateX(-50%)"
                width="32px"
                height="8px"
                backgroundColor="black"
                borderRadius="4px"
            ></Box>
            <Flex fontSize={"xs"}
                lineHeight="15px"
                color="grey.700"
                fontWeight={500}
                justifyContent='space-between'
                mt={2}>
                <Text color={fit < 2 ? 'black' : 'grey.700'}>
                    <FormattedMessage
                        defaultMessage="Runs Small"
                        id="pdp_reviews.actual_fit.runs_small"
                    />
                </Text>
                <Text color={fit >= 2 && fit <= 4 ? 'black' : 'grey.700'}
                    textAlign="center"
                    flex="1">
                    <FormattedMessage
                        defaultMessage="True to Size"
                        id="pdp_reviews.actual_fit.true_to_size"
                    />
                </Text>
                <Text color={fit > 4 ? 'black' : 'grey.700'}>
                     <FormattedMessage
                        defaultMessage="Runs Large"
                        id="pdp_reviews.actual_fit.runs_large"
                    />
                </Text>
            </Flex>
        </Box>
    );
};

ActualFit.propTypes = {
    fit: PropTypes.string
};

export default ActualFit;
